<script setup>
import { ref, computed } from 'vue'
import { useLocaleStore } from '@/stores/localeStore'
import cvData from '@/data/cv-data.json'

// Store pour la langue
const localeStore = useLocaleStore()
const currentLocale = computed(() => localeStore.currentLocale)

// Calcul de l'âge
const birthdate = new Date(2005, 11, 5) // change avec ta vraie date
const today = new Date()
let age = ref(today.getFullYear() - birthdate.getFullYear())
if (
  today.getMonth() < birthdate.getMonth() ||
  (today.getMonth() === birthdate.getMonth() && today.getDate() < birthdate.getDate())
) {
  age.value--
}

// Données CV
const profile = computed(() => cvData[currentLocale.value]?.profile || "")
const educationData = computed(() => cvData[currentLocale.value]?.education || [])
const experienceData = computed(() => cvData[currentLocale.value]?.workExperience || [])
const skillsData = computed(() => cvData[currentLocale.value]?.skills || [])
const languagesData = computed(() => cvData[currentLocale.value]?.languages || [])
</script>

<template>
  <div class="w-full h-full bg-white overflow-auto p-4">
    <!-- Header -->
    <div class="flex items-center mb-6">
      <!-- <img src="/img/icons/cv/paul-jaguin-photo-cv.webp" alt="Photo CV" class="w-20 h-20 rounded-full mr-4"/> -->
      <div>
        <h1 class="text-2xl font-trebuchet-pixel">Milo Barré</h1>
        <h2 class="text-lg font-trebuchet-pixel">{{ age }} years old</h2>
        <h3 class="font-trebuchet-pixel">{{ profile }}</h3>
      </div>
    </div>

    <!-- Éducation -->
    <section class="mb-6">
      <h2 class="font-trebuchet-pixel text-xl mb-2">Education</h2>
      <ul>
        <li v-for="edu in educationData" :key="edu.id" class="mb-3">
          <h3 class="font-trebuchet-pixel">{{ edu.degree }}</h3>
          <p>{{ edu.institution }}</p>
          <p>{{ edu.year }}</p>
        </li>
      </ul>
    </section>

    <!-- Expérience -->
    <section class="mb-6">
      <h2 class="font-trebuchet-pixel text-xl mb-2">Work Experience</h2>
      <ul>
        <li v-for="exp in experienceData" :key="exp.id" class="mb-3">
          <h3 class="font-trebuchet-pixel">{{ exp.jobTitle }}</h3>
          <p>{{ exp.company }}</p>
          <p>{{ exp.year }}</p>
          <ul v-if="exp.responsibilities.length > 0" class="ml-4 list-disc">
            <li v-for="(resp, idx) in exp.responsibilities" :key="idx">{{ resp }}</li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- Compétences -->
    <section class="mb-6">
      <h2 class="font-trebuchet-pixel text-xl mb-2">Skills</h2>
      <ul class="list-disc ml-4">
        <li class=" font-trebuchet-pixel"v-for="(skill, idx) in skillsData" :key="idx">{{ skill }}</li>
      </ul>
    </section>

    <!-- Langues -->
    <section>
      <h2 class="font-trebuchet-pixel text-xl mb-2">Languages</h2>
      <ul class="list-disc ml-4">
        <li v-for="(lang, idx) in languagesData" :key="idx">
          {{ lang.language }} – {{ lang.level }}
        </li>
      </ul>
    </section>

    <!-- Bouton PDF -->
    <a
      rel="noopener"
      :href="'pdf/CV_milo_' + localeStore.currentLocale + '.pdf'"
      :download="'CV_milo_' + localeStore.currentLocale + '.pdf'"
      class="absolute bottom-2 right-4 h-6 text-xxs border border-blue-500 bg-blue-200 rounded-sm leading-loose px-3 hover:shadow-lg cursor-pointer active:bg-blue-300"
    >
      Download CV
    </a>
  </div>
</template>

<style scoped>
/* Tu peux personnaliser les couleurs et polices ici */
</style>